module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-view"
  }, [_c('transition-group', {
    staticClass: "list-view-label-container",
    attrs: {
      "name": "slide",
      "tag": "ul"
    }
  }, _vm._l((_vm.labels), function(label) {
    return _c('li', {
      key: label.name,
      staticClass: "list-view-label-item",
      style: ({
        'background-color': '#' + label.color
      })
    }, [_c('span', [_vm._v(_vm._s(label.name))])])
  })), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "staggerd-fade",
      "tag": "ul",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.articleList), function(article, index) {
    return _c('li', {
      key: article.id,
      staticClass: "list-view-item",
      attrs: {
        "data-index": index
      }
    }, [_c('P', {
      staticClass: "list-view-item-time"
    }, [_vm._v(_vm._s(article.articleTime))]), _vm._v(" "), _c('h3', [_c('router-link', {
      attrs: {
        "to": {
          name: 'article',
          params: {
            id: article.number
          }
        }
      }
    }, [_vm._v(_vm._s(article.title))])], 1)], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36b537b5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list-view.vue
// module id = 358
// module chunks = 0